import React from 'react'
import journey from '../../media/journey.jpg'
import commitment from '../../media/commitment.jpg'
import {Container, Row, Col} from 'reactstrap'
import Saperator from '../Saperator'

const About = () => {
  return (
    <Container>
        <div id='about-section' className='about-section'> 
          <div className="cc-heading-a text-center"> About Us </div>

          <Row className='ourJourney about-row'>
            <Col lg={6}>
              <div className='mx-2'>
                <img src={journey} alt="Our Journey" width={'100%'}/>
              </div>
            </Col>
            <Col lg={6}>
              <div className='section-content mx-2'>
                <div className='secondary-heading'>Our Journey</div>
                <div className='cc-small-text'>
                  Since our founding in 2006, Al-Mutawakkal Traders has grown from a single rice business to a diversified trading company known for excellence across multiple sectors. We expanded into sugar, cars, and containers, always guided by the belief that quality is the cornerstone of success. Our journey is a testament to hard work, strategic growth, and an unwavering commitment to our clients. As we look to the future, we remain dedicated to pushing boundaries, expanding our reach, and maintaining the values that brought us here. 
                </div>
              </div>
            </Col>
          </Row>

          <Row className='ourCommitment about-row'>
            <Col lg={6}>
              <div className='section-content mx-2'>
                <div className='secondary-heading'>Our Commitment to Quality</div>
                <div className='cc-small-text'>
                  At Al-Mutawakkal Traders, quality is not just a promise; it’s our foundation. We have built our reputation on sourcing and delivering only the finest products in the market. Our rigorous quality assurance processes ensure that every item, from our premium rice to our Japanese cars, meets the highest standards. We partner with trusted suppliers and employ strict quality checks to guarantee that our clients receive nothing but the best. Our commitment to quality drives our success and fuels our passion for exceeding customer expectations. 
                </div>
              </div>
            </Col>
            <Col lg={6}>
              <div className='mx-2'>
                <img src={commitment} alt="Our Commitment to Quality" width={'100%'}/>
              </div>
            </Col>
          </Row>
         
        </div>
        <Saperator/>
    </Container>
  )
}

export default About